const serverName = "Amnesia";
export default serverName;